import { Breadcrumb, Button, Col, Form, Input, Row, Select } from "antd";
import styles from "./SearchCorporate.module.scss";
import { Content } from "antd/es/layout/layout";
import { regexFormater, validateInput } from "../../../../tools/tools";
import ReactInputMask from "react-input-mask";
import { useTranslation } from "react-i18next";
import { _adr } from "../../../../address";
import { HomeOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useDealer, useReport } from "../../../../tools/api";
import Result from "../result/result";
import { useSelector } from "react-redux";
const SearchCorporate = () => {
	const [t] = useTranslation("global");
	const [frmService] = Form.useForm();
	const nav = useNavigate();

	const { _currentUser } = useSelector((state) => {
		return state?.another;
	});

	const [search, setSearch] = useState({
		TypeOfSearch: [
			{ value: "0", name: "شناسه ملی" },
			{ value: "1", name: "شماره" },
		],
		changeTypeSearch: false,
		selectedType: "",
		isActive: false,
		searchItem: "",
	});

	const handleSubmit = async (value) => {
		if (value) {
			setSearch((search) => ({
				...search,
				isActive: true,
				selectedType: value.type,
				searchItem: value.certno || regexFormater(value.smsmobile).removeSpace(),
			}));
		}
	};
	return (
		<>
			<div className={`container-main ${styles.container_corporate}`}>
				<div className="g-hold-title-of-page">
					<Breadcrumb
						className="breadcrumbs"
						items={[{ href: _adr.Root + _adr.Home, title: <HomeOutlined /> }, { title: t("corporateSearch.title") }]}
					/>
					<div className="title-page">
						<h3>{t("corporateSearch.title")}</h3>
						<p></p>
					</div>
				</div>
				<div className="g-layout-content">
					<Content className={`g-layout-main ${styles.corporate_container} `}>
						<div className="g-format-page">
							<div className="g-body-format-page">
								<Form
									id="frmService"
									name="frmService"
									layout="vertical"
									form={frmService}
									onFinish={handleSubmit}
									initialValues={{ type: search.TypeOfSearch[0].value }}>
									<Row>
										<Col span={12}>
											<div className={styles.notemessage}>شماره موبایل و کدملی کاربر را وارد نمایید</div>
										</Col>
									</Row>
									<Row gutter={30}>
										<Col span={8} xl={8} lg={12} md={15} xs={24} sm={24}>
											<Form.Item className="input-normal" name="type" label="جستجو بر اساس">
												<Select
													placeholder="جستجو بر اساس"
													onChange={() => setSearch((search) => ({ ...search, changeTypeSearch: !search.changeTypeSearch }))}>
													{search.TypeOfSearch.map((type, key) => (
														<Select.Option key={key} value={type.value}>
															{type.name}
														</Select.Option>
													))}
												</Select>
											</Form.Item>
										</Col>
										<Col span={8} xl={8} lg={12} md={15} xs={24} sm={24}>
											{search.changeTypeSearch == false ? (
												<Form.Item
													className="input-normal"
													name="certno"
													label="شناسه ملی"
													rules={[
														validateInput({
															t: t,
															validate: true,
															type: "msisdnOrg",
														}),
													]}>
													<div>
														<Input dir="ltr" autoComplete="off" placeholder="شناسه ملی" maxLength={11} />
													</div>
												</Form.Item>
											) : (
												<Form.Item
													className="input-normal"
													name="smsmobile"
													label="شماره موبایل"
													rules={[
														validateInput({
															t: t,
															validate: true,
															type: "msisdnOrg",
														}),
													]}>
													<div>
														<ReactInputMask autoComplete="off" inputMode="numeric" className="msisdn-mask" dir="ltr" mask="0\999 999 99 99" />
													</div>
												</Form.Item>
											)}
										</Col>
										<Col span={8} xl={8} lg={12} md={15} xs={24} sm={24}>
											<Form.Item label="&nbsp;">
												<div className="holder-button">
													<Button className="btn-normal btn-green" htmlType="submit">
														جستجو
													</Button>
												</div>
											</Form.Item>
										</Col>
									</Row>
								</Form>
								{search.isActive && <Result user={_currentUser} type={search.selectedType} search={search.searchItem} />}
							</div>
						</div>
					</Content>
				</div>
			</div>
		</>
	);
};

export default SearchCorporate;
